module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_men_hairmake-dcbc2cb8e9a75a93ee1ea793e71d8bc8.jpg";